import React from 'react'

import { Text } from '@wartek-id/text'

import VideoCard from 'app/VideoRepository/components/VideoCard'

import type { PlaylistVideo } from 'types/video-inspirasi'

interface DesktopVideoSidebarProps {
  playlistName: string
  playlistId: number
  videos: PlaylistVideo[]
  currentVideoId: string
  onVideoSelect: (videoId: string) => void
}

const DesktopVideoSidebar = ({
  playlistName,
  playlistId,
  videos,
  currentVideoId,
  onVideoSelect,
}: DesktopVideoSidebarProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="p-4 border-b border-subdued">
        <Text variant="heading-sm">{playlistName}</Text>
        <Text variant="body-sm" color="subdued" className="mt-1">
          {videos.length} Video
        </Text>
      </div>
      <div className="overflow-y-auto max-h-[calc(100vh-16rem)]">
        {videos.map(({ title, videoId, duration, thumbnailUrl }, index) => (
          <VideoCard
            key={index}
            playlistId={playlistId}
            thumbnailUrl={thumbnailUrl}
            duration={duration}
            title={title}
            videoId={videoId}
            isActive={videoId === currentVideoId}
            onClick={() => onVideoSelect(videoId)}
          />
        ))}
      </div>
    </div>
  )
}

export default DesktopVideoSidebar
